import sojitzGcm from "./configs/sojitz/gcm.json";
import sojitzMinerva from "./configs/sojitz/minerva.json";

const configs = {
    "sojitz/gcm": sojitzGcm,
    "sojitz/minerva": sojitzMinerva,
};

const configKey = process.env.REACT_APP_CONFIG;
const config = configs[configKey];

if (!config) {
    throw new Error(
        `REACT_APP_CONFIG="${configKey}" is not valid. Available options: ${Object.keys(configs).join(", ")}`,
    );
}

export default config;
